import {
  PlantModule,
  PlantState,
  PlantMutationTree,
  PlantActionTree,
  PlantGetterTree,
} from '@/store/@types/plant';

import { getRecommendedPlants, getPlant } from '@/api/plant';

const state: PlantState = {
  dailyPlantData: null,
  allPlants: [],
  allPlantsPage: 1,
  recommendedPlants: [],
  searchPlantsResult: [],

  prefetchedPlants: {},
};

const mutations: PlantMutationTree = {
  SET_DAILY_PLANT_DATA(state, plantData) {
    state.dailyPlantData = plantData;
  },

  SET_ALL_PLANTS(state, plantsList) {
    state.allPlants = plantsList;
  },

  SET_ALL_PLANTS_PAGE(state, pageNumber) {
    state.allPlantsPage = pageNumber;
  },

  SET_RECOMMENDED_PLANTS(state, plantsList) {
    state.recommendedPlants = plantsList;
  },

  SET_SEARCH_PLANTS_RESULT(state, plantsList) {
    state.searchPlantsResult = plantsList;
  },

  RESET_PREFETCHED_PLANT(state) {
    state.prefetchedPlants = {};
  },

  SET_PREFETCHED_PLANT(state, plantData) {
    state.prefetchedPlants = {
      ...state.prefetchedPlants,
      [plantData.id]: plantData,
    };
  },
};

const actions: PlantActionTree = {
  setDailyPlantData({ commit }, plantData) {
    commit('SET_DAILY_PLANT_DATA', plantData);
  },

  setAllPlants({ commit }, plantsList) {
    commit('SET_ALL_PLANTS', plantsList);
  },

  setAllPlantsPage({ commit }, pageNumber) {
    commit('SET_ALL_PLANTS_PAGE', pageNumber);
  },

  async getRecommendedPlants({ commit }) {
    const plantsList = await getRecommendedPlants({});

    commit('SET_RECOMMENDED_PLANTS', plantsList);
  },

  setSearchPlantsResult({ commit }, plantsList) {
    commit('SET_SEARCH_PLANTS_RESULT', plantsList);
  },

  updatePrefetchedPlant({ commit }, plantData) {
    commit('SET_PREFETCHED_PLANT', plantData);
  },

  resetPrefetchedPlant({ commit }) {
    commit('RESET_PREFETCHED_PLANT');
  },

  async getPrefetchedPlantData({ commit, state }, plantId) {
    if (plantId in state.prefetchedPlants || window.innerWidth <= 768) {
      return;
    }

    try {
      const plantData = await getPlant(plantId);

      commit('SET_PREFETCHED_PLANT', plantData);
    } catch (error) {
      void error;
    }
  },
};

const getters: PlantGetterTree = {
  recommendedPlants: (state) => state.recommendedPlants,
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
} as PlantModule;
